// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialStudents = () => {
  const item = window.sessionStorage.getItem("studentsData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

const initialCourses = () => {
  const item = window.sessionStorage.getItem("courseData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : [];
};
const initialAttendance = () => {
  const item = window.sessionStorage.getItem("attendanceData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};
const initialFeeStructure = () => {
  const item = window.localStorage.getItem("feeStructureData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const getCourseData = createAsyncThunk(
  "institute/getCourseData",
  async (obj) => {
    const res = await axios.get(
      `${process.env.REACT_APP_COLLEGE_ERP_API}api/courses`,
      {
        params: {
          branch: obj.branch,
        },
        headers: {
          Authorization: `Bearer ${obj.token}`,
        },
      }
    );
    //console.log(res);
    return res.data;
  }
);
export const getAttendanceData = createAsyncThunk(
  "institute/getAttendanceData",
  async (obj) => {
    const res = await axios.get(
      `${process.env.REACT_APP_COLLEGE_ERP_API}get-attendance`,
      {
        params: {
          branch: obj.branch,
          date: obj.selectedDate,
        },
        headers: {
          Authorization: `Bearer ${obj.token}`,
        },
      }
    );
    //console.log(res);
    return res.data;
  }
);

export const instituteSlice = createSlice({
  name: "institute",
  initialState: {
    courseData: initialCourses(),
    attendanceData: initialAttendance(),
  },
  extraReducers: (builder) => {
    builder
      // getCourseData cases
      .addCase(getCourseData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCourseData.fulfilled, (state, action) => {
        state.loading = false;
        state.courseData = action.payload;
        sessionStorage.setItem("courseData", JSON.stringify(action.payload));
      })
      .addCase(getCourseData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // getAttendanceData cases
      .addCase(getAttendanceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAttendanceData.fulfilled, (state, action) => {
        state.loading = false;
        state.attendanceData = action.payload;
        sessionStorage.setItem(
          "attendanceData",
          JSON.stringify(action.payload)
        );
      })
      .addCase(getAttendanceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { handleLogin, handleLogout, handleBranch, handleApproval } =
  instituteSlice.actions;

export default instituteSlice.reducer;
